module.exports = __webpack_public_path__ + "img/sbunyavanich.bcff5583.jpeg";